// extracted by mini-css-extract-plugin
module.exports = {"userActionCount":"mIndex_userActionCount__wHmRS","lg":"mIndex_lg__Wiyj2"};